import { Dialog, Box, Grid, TableContainer, Table, TableHead, TableRow, TableCell, Button, IconButton, Collapse, Stack, Divider } from '@mui/material'
import React, { useEffect, useState } from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import useFetch from "../../../utils/useFetch";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useNavigate } from "react-router-dom";
import axios from "../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { getisEmp, getOrgId } from "../../../utils/Token";
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';


export default function VerifyCourses({ activestep, dataset }) {
  const [getCourse, setCourses] = React.useState([]);
  const [getaddedCourse, setAddedCourses] = React.useState([]);
  const [open, setOpen] = useState(false);
  const [openTraining, setOpenTraining] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [openpop, setOpenpop] = React.useState(false);
  const [Dis, setDis] = React.useState(false);

  // const handleClickOpenpop = (e) => {
  //   setOpenpop(true);
  // };
  // const handlePopClose = () => {
  //   setOpenpop(false);
  // };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const navigate = useNavigate();
  const handleRowClick = (training) => {
    setOpenTraining((prevOpen) =>
      prevOpen === training ? null : training
    );
  };

  useEffect(() => {
    axios.get("Employee/GetCoursesAddedToCart?VendorId=" + getOrgId())
      .then(res => {
        if (res?.data) {
          setCourses(res?.data?.data?.organizaionDetails)
        }

        else {
          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setIsLoading(false);
      });
  }, [refresh]);
  const HandleNext1 = (value) => {
    const IsEmp = getisEmp();
    setIsLoading(true);
    axios.post("Employee/GetTrainingPaymentURLs?VendorId=" + getOrgId(),)
      .then((res) => {
        if (res?.data?.responseCode == 100) {
          // activestep(value)
          // dataset(res.data.data)

          if (IsEmp == "true") {
            if (res?.data?.data?.url == null) {
              navigate("/EmployeeQuizzes")
            }
          } else {
            navigate("/EmployeesList")
          }

        } else {

          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        setIsLoading(false);
      })

  };
  const HandleNext = (value) => {
    setIsLoading(true);
    axios.post("Employee/GetTrainingPaymentURLs?VendorId=" + getOrgId(),)
      .then((res) => {
        if (res?.data?.responseCode == 100) {
          activestep(value)
          dataset(res?.data?.data)
        } else {

          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        setIsLoading(false);
      })

  };



  const deletedata = (value, training) => {
    const data = {
      "vendorId": getOrgId(),
      "employeeId": value?.employeeId,
      "courseId": training
    }
    axios
      .post("Employee/DeleteCartEmployee", data,
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (res?.data?.responseCode == "100") {
          toast.success(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

          setRefresh(!refresh)

        } else {
          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

        }

      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const EmptyCart = () => {
    setIsLoading(true);
    setDis(true);
    axios
      .post("Employee/RemoveCartItems",
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (res?.data?.responseCode == "100") {
          toast.success("Cart is empty", {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setRefresh(!refresh);
          setOpenpop(false);
          setDis(false);
        } else {
          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

        }

      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
        setDis(false);
      });
  };

  const actual = getCourse?.map((client) =>
    client?.trainings?.map((training) => (
      training?.employees?.reduce((total, employee) => total + employee?.amount, 0)
    ))
  );

  const totals = actual?.map((item) => (
    item?.reduce((acc, currentValue) => acc + currentValue, 0)
  ));

  const grandTotal = totals?.reduce((acc, currentValue) => acc + currentValue, 0);

  var totalFeecap = getCourse?.reduce(function (acc, client) {
    return acc + client?.feecap;
  }, 0);

  const StyledTableRow = styled(TableRow)(({ theme }) => ({

    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  return (
    <Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />

      {/*Empty cart function ------ */}
      <Dialog
        open={openpop}
        fullScreen={fullScreen}
        onClose={() => setOpenpop(false)}
      >
        <div style={{ display: "flex", }}>
          <DialogTitle sx={{
            textAlign: "left",
            fontWeight: 500,
            fontSize: 20,
            flex: 1,
          }}
          >
            {/* {"Are you sure you want to clear this items?"} */}
            {"Are you sure you want to clear all the items?"}</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => setOpenpop(false)}
            sx={(theme) => ({
              color: "#D20103",
            })}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <DialogActions sx={{ marginTop: "3px" }}>
          <div className="login-help__buttonContainer mt-4">
            <Button variant="contained" className="login-help-button-cancel mx-4"
              onClick={() => setOpenpop(false)}>{"Cancel"}</Button>
            <Button variant="contained"
              className="login-button-request mx-2" disabled={Dis} onClick={EmptyCart}>{"Ok"}</Button>
          </div>
        </DialogActions>
      </Dialog>
      {/* ------ */}

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={8} md={8}>
            <Box border={1}
              borderLeft={1}
              borderRight={1}
              borderColor="#e4e7ec" sx={{ padding: "10px", backgroundColor: "#fff" }}>
              <Stack direction={"row"} spacing={5}>
                <p style={{ color: "#101828", fontSize: "20px", marginBottom: "20px", fontWeight: "600" }}> Item Summary</p>
                {/* <div className='mt-1' style={{ marginLeft: "auto" }}>
                  <Button variant="outlined"
                    sx={{ padding: "8px" }} hidden={getCourse?.length == 0} disabled={Dis} onClick={() => setOpenpop(true)}>
                    <DeleteOutlineIcon style={{ cursor: "pointer" }} />   Clear Cart
                  </Button>
                </div> */}
              </Stack>
              <Divider
                sx={{
                  marginBottom: 2,
                  backgroundColor: "#667085;",
                  height: "2px",
                }}
              />
              <TableContainer sx={{ maxHeight: 200, overflowY: "auto" }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    {getCourse?.length > 0 ?
                      getCourse?.map((client) => (
                        <React.Fragment key={client?.clientId}>
                          {client?.trainings?.map((training) => (
                            <React.Fragment key={training?.courseId}>
                              <StyledTableRow style={{ backgroundColor: "#DEEDF7", color: "#2A93DB" }}>
                                <TableCell align="left" style={{ color: "#2A93DB", width: "500px" }}>
                                  {training?.courseName}
                                </TableCell>
                                <TableCell align="center" style={{ color: "#2A93DB" }}>${(training?.employees?.reduce((total, employee) => total + employee?.amount, 0) || 0)}</TableCell>
                                <TableCell align="right" style={{ color: "#2A93DB" }}>  <IconButton
                                  size="small"
                                  onClick={() => handleRowClick(training)}
                                >
                                  {openTraining === training ? (
                                    <KeyboardArrowUpIcon style={{ color: "#2A93DB" }} />
                                  ) : (
                                    <KeyboardArrowDownIcon style={{ color: "#2A93DB" }} />
                                  )}
                                </IconButton></TableCell>

                              </StyledTableRow>


                              <TableCell colSpan={12} style={{ borderBottom: "1px solid #fff" }}>
                                <Collapse
                                  in={openTraining === training}

                                  TransitionProps={{ unmountOnExit: true }}
                                >
                                  <Table size="small" aria-label="purchases" sx={{ border: "1px solid #ccc", borderCollapse: "collapse" }}>
                                    {training?.employees?.map((row) => (
                                      <StyledTableRow key={row?.employeeId}>
                                        <TableCell align="left" style={{ width: "480px" }}>{row?.employeeName}</TableCell>
                                        <TableCell align="center">${row?.amount}</TableCell>
                                        <TableCell align="right"><DeleteOutlineIcon style={{ cursor: "pointer" }} onClick={() => deletedata(row, training?.courseId)} /></TableCell>
                                      </StyledTableRow>
                                    ))}
                                  </Table>
                                </Collapse>
                              </TableCell>

                            </React.Fragment>
                          ))}
                        </React.Fragment >
                      ))
                      : <>
                        <p style={{ textAlign: "center" }} hidden={isLoading}>Cart is empty</p>
                      </>
                    }

                  </TableHead>
                </Table>
              </TableContainer>
              <div className='mt-2' style={{ marginLeft: "auto" }}>
                <Button variant="outlined"
                  sx={{ padding: "8px" }} hidden={getCourse?.length == 0} disabled={Dis} onClick={() => setOpenpop(true)}>
                  <DeleteOutlineIcon style={{ cursor: "pointer" }} />   Clear Cart
                </Button>
              </div>
              {/* <div hidden={getCourse.length==0}>Cart is empty</div> */}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box border={1}
              borderLeft={1}
              borderRight={1}
              hidden={grandTotal == undefined || getCourse?.length == 0}
              borderColor="#e4e7ec" sx={{ padding: "10px", backgroundColor: "#fff" }}>
              <p style={{ color: "#101828", fontSize: "20px", marginBottom: "20px", fontWeight: "600" }}>Order Summary
              </p>
              <hr />
              <Box sx={{ fontSize: "14px", padding: "10px" }}> <span>Actual Amount</span>  <span style={{ color: "#667085", float: "right" }}>${grandTotal}</span></Box>

              <hr />
              <Box sx={{ fontSize: "14px", padding: "10px" }}> <span>Fee Cap Applicable</span>  <span style={{ color: "#667085", float: "right" }}>-${totalFeecap}</span></Box>
              <br />
              <Box sx={{ fontSize: "14px", backgroundColor: "#F2F4F7", padding: "10px" }}> <span>TOTAL AMOUNT</span>  <span style={{ color: "#667085", float: "right" }}>${(grandTotal - totalFeecap)?.toFixed(2)}</span></Box>
              <br />
              {/* <Button variant="contained" sx={{ padding: "10px" }} onClick={() => HandleNext(2)}>
                Proceed to Pay
              </Button> */}
              {grandTotal - totalFeecap == 0 ?
                <Button variant="contained" sx={{ padding: "20px" }} onClick={() => HandleNext1(2)}>
                  Proceed To Assign
                </Button> : <Button variant="contained" sx={{ padding: "20px" }} onClick={() => HandleNext(2)}>
                  Proceed to Pay
                </Button>

              }
            </Box>
          </Grid>

        </Grid>
      </Box>
    </Box >
  )
}
